import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ApiUsers, GungSettingsApiUsersService } from '../../../services/gung-settings-api-users.service';
import { ListItemRendererComponent } from 'gung-list';
import { GungModalService } from '../../../services/gung-modal/gung-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { GungNotificationService } from 'gung-common';

@Component({
    selector: 'lib-gung-settings-api-users-table',
    templateUrl: './gung-settings-api-users-table.component.html',
    styleUrl: './gung-settings-api-users-table.component.scss',
    standalone: false
})
export class GungSettingsApiUsersTableComponent
  extends ListItemRendererComponent<ApiUsers[]>
  implements OnInit, AfterViewInit
{
  constructor(
    protected modalService: GungModalService,
    protected aiUsersService: GungSettingsApiUsersService,
    protected translateService: TranslateService,
    protected notificationService: GungNotificationService
  ) {
    super();
  }

  ngOnInit() {}

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  edit(edit: ApiUsers) {
    this.modalService.openEditApiUser(edit).then(res => {
    });
  }

  delete(edit: ApiUsers) {
    this.modalService.openConfirmYesNoModal(
      this.translateService.instant('DELETE'),
      this.translateService.instant('CONFIRM_DELETION', {value: edit.username}),
      {size: 'sm'},
      'YES',
      'NO'
    ).then(res =>{
      if(res){
        this.aiUsersService.delete(edit).subscribe(response => {
          if(response.success){
         
            this.notificationService.notify('', this.translateService.instant('DELETED'), 'success');
            
          }else{
            this.notificationService.notify('', this.translateService.instant('ERROR'), 'error');
          }
        });
      }
    });
   
  }
}
